export default __webpack_public_path__ + "fonts/d65966541eb07b95368c86e9fa55a7c6.svg";